import { WindowConfiguration } from './window-configuration';
import { HSActiveConfiguration } from './hs-active-configuration';

export class HSConfiguration extends WindowConfiguration {

    type: 'hs' | 'folding_door' | 'sliding_door' = 'hs';

    height = 2000;
    width = 2000;

    sashesType: 'Fix' | 'FixSash' | 'Func' | 'Mix' = 'Func';

    constructor(
        configuration?,
        dataRequiredToUpdate?: any,
        conversion = true,
        configuratorsDataService?,
        colorsDefaultsService?,
        langCode = configuration?.langCode || 'pl'
    ) {
        super(configuration, dataRequiredToUpdate, false, configuratorsDataService, colorsDefaultsService, langCode);

        if (HSConfiguration.is(configuration) && conversion) {
            this.runConversion(configuration, dataRequiredToUpdate);
        } else if (HSActiveConfiguration.is(configuration)) {
            this.height = configuration.Height;
            this.sashesType = configuration.SashesType;
            this.width = configuration.Width;
        }
    }

    public static is(configuration): configuration is HSConfiguration {
        return (
            configuration instanceof HSConfiguration
            || (configuration.$version && !configuration.active)
        );
    }
}
